import React from 'react';
import { EditPrintTemplateDialog, ErpDataTableV2 } from '@/components/custom/erp';
import { ActionBar, SearchDialog } from './components';
import { initialSearchValues } from './schema';
import { useReportData } from './hooks';

export default function BangKeCongNoTheoHoaDonMuaPage() {
  const {
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,

    handleInitialSearchClose,
    handleInitialSearch,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,

    tables,
    handleRowClick,
    isLoading,

    handleRefreshClick,
    handleFixedColumnsClick,
    handleExportDataClick
  } = useReportData();

  return (
    <div className='flex h-full min-h-screen w-full min-w-0 flex-col overflow-hidden'>
      {initialSearchDialogOpen && (
        <SearchDialog
          open={initialSearchDialogOpen}
          onClose={handleInitialSearchClose}
          onSubmit={handleInitialSearch}
          formMode={'add'}
          initialData={initialSearchValues}
        />
      )}

      <EditPrintTemplateDialog
        open={editPrintTemplateDialogOpen}
        onClose={handleClosePrintTemplateDialog}
        onSave={handleSavePrintTemplate}
      />
      {showTable && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onPrintClick={() => {}}
            onRefreshClick={handleRefreshClick}
            onFixedColumnsClick={handleFixedColumnsClick}
            onExportClick={handleExportDataClick}
            onEditPrintClick={handleEditPrintTemplateClick}
            searchParams={searchParams}
          />

          <div className='min-h-0 min-w-0 flex-1 overflow-hidden'>
            <ErpDataTableV2 tables={tables} onRowClick={handleRowClick} loading={isLoading} />
          </div>
        </>
      )}
    </div>
  );
}
